import { render, staticRenderFns } from "./xeScatchColorPicker.vue?vue&type=template&id=3d451d0f&scoped=true"
import script from "./xeScatchColorPicker.vue?vue&type=script&lang=js"
export * from "./xeScatchColorPicker.vue?vue&type=script&lang=js"
import style0 from "./xeScatchColorPicker.vue?vue&type=style&index=0&id=3d451d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d451d0f",
  null
  
)

export default component.exports